import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { toast } from 'react-hot-toast';
import { supabase } from '../../lib/supabase';

export function SignUpSection() {
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!formData.email || !formData.firstName || !formData.lastName) {
      toast.error('Please fill in all fields');
      return;
    }

    setIsSubmitting(true);
    try {
      const { error } = await supabase
        .from('email_notifications')
        .insert([{ email: formData.email.toLowerCase() }]);

      if (error) throw error;

      toast.success('Thank you for signing up!');
      setFormData({ firstName: '', lastName: '', email: '' });
    } catch (error) {
      console.error('Error saving email:', error);
      toast.error('Failed to sign up. Please try again.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4">
        <div className="flex flex-col md:flex-row md:items-start md:justify-between">
          <div className="md:w-1/2 md:pr-12">
            <h2 className="text-[32px] sm:text-[48px] text-[#800020] mb-8 sm:mb-12" style={{ fontFamily: 'Noto Serif Ethiopic Condensed' }}>sign-up so you don't miss a beat</h2>
        
            <form onSubmit={handleSubmit} className="space-y-4 sm:space-y-6">
              <div className="grid grid-cols-2 gap-4">
                <div className="relative">
                  <input
                    type="text"
                    placeholder="FIRST NAME"
                    value={formData.firstName}
                    onChange={(e) => setFormData(prev => ({ ...prev, firstName: e.target.value }))}
                    className="w-full px-4 sm:px-6 py-3 sm:py-4 bg-[#ddd9d9] border-2 border-dashed border-[#800020] rounded-full text-[#800020] placeholder-[#800020] focus:outline-none focus:border-[#800020] text-sm sm:text-base"
                    required
                  />
                </div>
                <div className="relative">
                  <input
                    type="text"
                    placeholder="LAST NAME"
                    value={formData.lastName}
                    onChange={(e) => setFormData(prev => ({ ...prev, lastName: e.target.value }))}
                    className="w-full px-4 sm:px-6 py-3 sm:py-4 bg-[#ddd9d9] border-2 border-dashed border-[#800020] rounded-full text-[#800020] placeholder-[#800020] focus:outline-none focus:border-[#800020] text-sm sm:text-base"
                    required
                  />
                </div>
              </div>
              <div className="relative">
                <input
                  type="email"
                  placeholder="EMAIL"
                  value={formData.email}
                  onChange={(e) => setFormData(prev => ({ ...prev, email: e.target.value }))}
                  className="w-full px-4 sm:px-6 py-3 sm:py-4 bg-[#ddd9d9] border-2 border-dashed border-[#800020] rounded-full text-[#800020] placeholder-[#800020] focus:outline-none focus:border-[#800020] text-sm sm:text-base"
                  required
                />
              </div>
              <button
                type="submit"
                disabled={isSubmitting}
                className="w-full px-12 py-4 bg-[#800020] text-white rounded-full hover:opacity-90 transition-opacity disabled:opacity-50 uppercase text-sm sm:text-base"
              >
                {isSubmitting ? 'Signing up...' : 'Sign Up'}
              </button>
            </form>
          </div>
          
          <div className="md:w-1/2 md:pl-12 mt-12 md:mt-0">
            <div className="flex justify-between">
              <div>
                <h3 className="text-[#800020] font-bold mb-4">WE ARE TEZHLY</h3>
                <ul className="space-y-2">
                  <li><Link to="/community" className="text-[#800020] hover:opacity-80">Community</Link></li>
                  <li><Link to="/jobs" className="text-[#800020] hover:opacity-80">Job Board</Link></li>
                  <li><Link to="/courses" className="text-[#800020] hover:opacity-80">Courses</Link></li>
                  <li><Link to="/blog" className="text-[#800020] hover:opacity-80">Blog</Link></li>
                  <li><Link to="/admin/layoffs" className="text-[#800020] hover:opacity-80">Live Layoff Tracker</Link></li>
                  <li><Link to="/faqs" className="text-[#800020] hover:opacity-80">FAQs</Link></li>
                </ul>
              </div>
              
              <div>
                <h3 className="text-[#800020] font-bold mb-4">CORPORATE STUFF</h3>
                <ul className="space-y-2">
                  <li><Link to="/privacy" className="text-[#800020] hover:opacity-80">Privacy Policy</Link></li>
                  <li><Link to="/terms" className="text-[#800020] hover:opacity-80">Terms & Conditions</Link></li>
                  <li><Link to="/partners" className="text-[#800020] hover:opacity-80">Partners</Link></li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}